import React from "react";
import { Updater, async, fromJSX, Widget } from "widgets-for-react";
import { InviewProps, SVGIconProps } from "../blocksState";
import { EventPageWithCount } from "./allEventsBlockApi";
import { AllEventsBlockLayout } from "./allEventsBlockLayout";
import { AllEventsBlockState } from "./allEventsBlockState";

export type AllEventsBlock = {
    index: number
    inview?: InviewProps
    title?: React.ReactNode
    teaser: boolean
    eventsState: AllEventsBlockState
    SVGIcon?: SVGIconProps
}

export const allEventsBlockWidget = (
    block: AllEventsBlock
): Widget<Updater<AllEventsBlockState>> =>
async<EventPageWithCount>(block.eventsState, (eventData) =>
    fromJSX(() => <AllEventsBlockLayout {...block} children={eventData.Pages} eventCount={eventData.Count} />)
  )
